import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const RoadBlockIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.84 19.8L10 3.8H14L19.16 19.8H4.84ZM10.06 8.84H13.94L12.88 5.52H11.12L10.06 8.84ZM8.58 13.44H15.42L14.52 10.56H9.48L8.58 13.44ZM7.06 18.08H16.94L16.02 15.16H7.98L7.06 18.08Z" />
    </SvgIcon>
  );
});
